export const serviceStatusList = [
  'ordered',
  'preparing',
  'ready',
  'out',
  'delivered',
  'cancelled',
];
